import { EvaluationColor } from '@repo/types';
import { Icon, RangeBar, Typography } from '@repo/ui';
import c from 'classnames';
import { userValueFormat } from 'helpers';
import useCurrentKitAndTinyAccount from 'hooks/useCurrentKitAndTinyAccount';
import { useLocation, useNavigate } from 'react-router-dom';
import type { SingleConditionMetric } from 'services/conditions/useConditionMetrics';
import { getEvaluationIconFromColor } from '../../Insights/EvaluationGroupsSummary/EvaluationGroupsSummary';
import styles from './ConditionMetricRow.module.css';

export const ConditionMetricRow = ({
  metric,
}: {
  metric: SingleConditionMetric;
}) => {
  const { currentKitId } = useCurrentKitAndTinyAccount();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const ranges = (metric.ranges ?? []).map(range => ({
    range_lower: range.range_lower,
    range_upper: range.range_upper,
    evaluation_color: range.evaluation_color as EvaluationColor,
  }));
  const valueDisplay = userValueFormat(metric.user_value, metric.data_type);

  const bar = ranges.length ? (
    <RangeBar
      ranges={ranges}
      value={metric.user_value}
      showValue
      valueDisplay={valueDisplay}
      variant='result'
    />
  ) : null;

  return (
    <div
      className={styles.row}
      role='button'
      tabIndex={0}
      onClick={() =>
        navigate(
          `/results/${currentKitId}/insights/all-insights/${metric.metric_id}`,
          { state: { from: pathname } },
        )
      }
    >
      <div className={styles.header}>
        <div className={styles.nameGroup}>
          <Icon
            name={getEvaluationIconFromColor(metric.evaluation_color)}
            size='m'
            className={c(styles.icon, styles[metric.evaluation_color])}
          />
          <Typography variant='body-s' className={styles.name}>
            {metric.name}
          </Typography>
        </div>
        <div className={styles.rightGroup}>
          {bar && (
            <div className={c(styles.barSlot, 'hide-on-mobile')}>{bar}</div>
          )}
          <Icon name='chevronForward' size='m' className={styles.chevron} />
        </div>
      </div>
      {bar && (
        <div className={c(styles.barMobile, 'hide-on-desktop')}>{bar}</div>
      )}
    </div>
  );
};
